import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function ServiceInfoAreas({ icon, color, title, description, link }) {
  const cardColors = {
    blueGray: "bg-blueGray-50",
    red: "bg-red-50",
    orange: "bg-orange-50",
    amber: "bg-amber-50",
    emerald: "bg-emerald-50",
    teal: "bg-teal-50",
    lightBlue: "bg-lightBlue-50",
    indigo: "bg-indigo-50",
    purple: "bg-purple-50",
    pink: "bg-pink-50",
  };

  const textColors = {
    blueGray: "text-blueGray-700",
    red: "text-red-500",
    orange: "text-orange-500",
    amber: "text-amber-500",
    emerald: "text-emerald-500",
    teal: "text-teal-500",
    lightBlue: "text-lightBlue-700",
    indigo: "text-indigo-500",
    purple: "text-purple-500",
    pink: "text-pink-500",
  };

  return (
    <div className={`p-8 ${cardColors[color]} relative group`}>
      <div className="flex items-center mb-4">
        <div
          className={`text-${color}-500 bg-white shadow-md rounded-full flex items-center justify-center p-3 mr-4`}
          style={{ width: "56px", height: "56px" }}
        >
          <i className={`${icon} text-2xl`} />
        </div>
        <h4 className={`text-xl font-bold`}>{title}</h4>
      </div>
      <p className="text-gray-700 mb-4">{description}</p>
      {link && (
        <div className="flex items-center absolute bottom-4 left-6 transform translate-y-10 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
          {link.to ? (
            <Link
              to={link.to}
              className={`${textColors[color]} hover:underline`}
            >
              {link.text} <i className="fas fa-arrow-right ml-2"></i>
            </Link>
          ) : (
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`${textColors[color]} hover:underline`}
            >
              {link.text} <i className="fas fa-arrow-right ml-2"></i>
            </a>
          )}
        </div>
      )}
    </div>
  );
}

ServiceInfoAreas.defaultProps = {
  color: "blueGray",
  link: {},
};

ServiceInfoAreas.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.object,
  color: PropTypes.oneOf([
    "blueGray",
    "red",
    "orange",
    "amber",
    "emerald",
    "teal",
    "lightBlue",
    "indigo",
    "purple",
    "pink",
  ]),
};
